


































































import { Component, Vue } from 'vue-property-decorator';
import AppMenuService from '@/services/appMenu.service';
import ConfigUtils from '@/utils/config.utils';
import SidebarMenuItem from '@/components/base-layout/menu/SidebarMenuItem.vue';
import TaftIconButton from '@/components/base-layout/TaftIconButton.vue';
import TaftUserName from '@/components/base-layout/TaftUserName.vue';

@Component({
  components: { SidebarMenuItem, TaftUserName, TaftIconButton },
})
export default class SubHeaderMenu extends Vue {
  private ministryAppMenuItems = AppMenuService.getMinistryMenuItems();

  goTo(menuItem) {
    this.$router.push(menuItem.route);
  }

  isActive(menuItem: any) {
    return this.$route.path === menuItem.route;
  }

  openSpecialAuthForm() {
    this.$router.push('/ministry/task-list');
    window.open(ConfigUtils.getSpecialAuthUrl(), '_blank');
  }
}
